module.exports = __webpack_public_path__ + "static/media/header_openhealth.bbcfa33e.jpg";